import { Button } from '@mantine/core';
import { FC } from 'react';

import BaseModal from '@/components/BaseModal.tsx';

interface Props {
    visible: boolean;
    setVisible: (isVisible: boolean) => void;
    setConfirm: (confirm: boolean) => void;
}

const PatientDuplicationPopup: FC<Props> = ({ visible, setVisible, setConfirm }) => {
    const close = (): void => {
        setVisible(false);
    };

    const onConfirm = (): void => {
        setConfirm(true);
        setVisible(false);
    };

    const footer = (
        <div className="flex flex-1 justify-center">
            {/* EN: confirm */}
            <Button onClick={onConfirm}>Bestätigen</Button>
        </div>
    );

    return (
        <BaseModal
            opened={visible}
            onClose={close}
            size="lg"
            // EN: Creating a second profile in the PVS system.
            title="Erstellung eines zweiten Profils im PVS-System"
            footer={footer}
            zIndex={420}
        >
            <div className="flex flex-col gap-4">
                {/* EN: Please note that if there are more than two locations for the same cost center, a new profile will be created in the PVS system. */}
                Bitte beachten Sie, dass bei mehr als zwei Betriebsstätten für denselben Kostenträger ein neues Profil
                im PVS-System erstellt wird.
            </div>
        </BaseModal>
    );
};

export default PatientDuplicationPopup;
